import React, { Component } from 'react'
import {
  Form, Input
} from 'antd'
import { withTranslation } from 'react-i18next';

class MenuForm extends Component {
  constructor(props) {
    super(props);
    this.state = {

    };
  }
  render() {
    const {t,fieldChange,menu}=this.props
    const formItemLayout = {
      labelCol: {
        xs: { span: 4 },
        sm: { span: 4 },
      },
      wrapperCol: {
        xs: { span: 20 },
        sm: { span: 20 },
      },
    }
    return (
      <Form {...formItemLayout}>
        <Form.Item label={t('Menu Name')}>
          <Input value={menu.name} onChange={(e)=>{fieldChange('name',e.target.value)}}></Input>
        </Form.Item>
        <Form.Item label={t('Menu URL')}>
          <Input value={menu.url} onChange={(e)=>{fieldChange('url',e.target.value)}}></Input>
        </Form.Item>
      </Form>
    )
  }
}

export default withTranslation()(MenuForm)